export const translations = {
	'Generic': { no: 'Generisk' },
	'Geotag': { no: 'Geotag' },
	'Latitude': { no: 'Breddegrad' },
	'Longitude': { no: 'Lengdegrad' },
	'Click to change asset icon': { no: 'Klikk for å endre ressurs ikon' },
};
